import constants from '../constants';
import type { AllActionTypes } from '../constants';
import type { PartialFilterType } from '../../models/Types';

export type SetFilter = (partialFilterObj?: PartialFilterType) => Promise<unknown>;
export type Actions = { type: AllActionTypes; payload: SetFilter };

const setFilter = (state: SetFilter = () => Promise.resolve(), action: Actions): SetFilter => {
  switch (action.type) {
    case constants.INIT_SET_FILTER:
      return action.payload;
    default:
      return state;
  }
};

export default setFilter;
